import React, { Component } from 'react';
import Dialog from '../UI/Dialog';

class PromptDialog extends Component {

    render() {
        return (
            <Dialog open={ this.props.open } handleClose={ this.props.close }>
                <form>
                    <div className="popup-title">
                        <h2>{ this.props.prompt }</h2>
                    </div>
                    <div className="popup-meta flex justify-end">
                        <button className="no-style w-600 pointer mx-20" type="button"
                                onClick={ this.props.close }>
                            No
                        </button>
                        <button type="button" onClick={ this.props.changeStatus } className="btn filled primary min-120">
                            Yes
                        </button>
                    </div>
                </form>
                <button className="no-style close-btn" onClick={ this.props.close }>×</button>
            </Dialog>
        );
    }
}

export default PromptDialog;



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/PromptDialog.js